/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SwaggerResource {
    getFixupPrototypeFunction() { return SwaggerResource.fixupPrototype; }

    static newInstance(model: Partial<SwaggerResource>): SwaggerResource {
        let obj = Object.assign(new SwaggerResource(), model);
        SwaggerResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SwaggerResource>): SwaggerResource {
        if (!model) return null;
        return SwaggerResource.newInstance(<SwaggerResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SwaggerResource) {
        if (!obj) return;

        models.SwaggerResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SwaggerResource): boolean {
        Object.setPrototypeOf(obj, SwaggerResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.operations) {
            for (let val of this.operations) {
                models.SwaggerResourceOperation.fixupPrototype(val);
            }
        }
    }

    /**
     * select the cloud account type
     */
    service_name: models.CloudServiceName;

    /**
     * Resource Category
     */
    resource_category: string;

    /**
     * Resource Type
     */
    resource_type: string;

    /**
     * Resource
     */
    resource: string;

    /**
     * Resource Operations
     */
    operations: Array<models.SwaggerResourceOperation>;

}
